package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class ContractTypeDto(
    val id: String = "",
    val label: String = "",
    val systemType: String = "NOT_SET",
    val countryCode: String = "PL"
)
